
(ns app.strive-forms.question-fields.dropdown-field
  (:require-macros [reagent-mui.util :refer [react-component]])
  (:require [app.strive-forms.component-multi-methods :refer [show-action-btn?]]
            [app.strive-forms.events :as events ]
            [app.strive-forms.helper-functions :refer [get-button-label]]
            [app.strive-forms.styles :refer [action-button-area-style
                                             action-button-style warning-notification]]
            [re-com.box :refer [gap]]
            [re-com.core :as re-com :refer [at v-box]]
            [re-frame.core :as re-frame]
            [reagent-mui.material.autocomplete :refer [autocomplete] :rename {autocomplete mui-autocomplete}]
            [reagent-mui.material.text-field :refer [text-field]]
            [reagent.core :as r]))

(defn map-dropdown-options [data]
  (map  #(-> %
             (assoc :label (% :value))) data))


;; (defmethod calc-error-message "dropdown" [props]
;;   "")

(defmethod show-action-btn? "dropdown" [props]
  false)

(defn get-dropdown-options [data alpha-order?]
  (cond->> (map-dropdown-options data)
    alpha-order? (sort-by :label)))

(defn get-selected-values [selected-values options]
  (let [copy-of-options (r/atom options)]
    (reset! selected-values (map (fn [value]
                                   (or (:label value) value))
                                 (js->clj @copy-of-options :keywordize-keys true)))))

;; destructure with keys and values ((:additional_settings field) to here)
(defn dropdown-field [{:keys [field field-id index selected-language theme-data form-messages current-page input-data on-submit pre-filled regenerate-display-fields hidden-fields display-fields]}]
  (let [settings (merge
                  (select-keys (:additional_settings field) [:allow_multi :count_range :imply_other :alpha_order])
                  {:is_required (:is_required field)})
        dropdown-options (r/atom (get-dropdown-options (:multi_select_items field) (:alpha_order settings)))
        selected-values (r/atom nil)]
    (fn [{:keys [field field-id index selected-language theme-data form-messages current-page input-data hidden-fields display-fields]}]
      [v-box
       :justify :center
       :align :center
       :children [[mui-autocomplete {:id            "autocomplete-input"
                                     :style {:width (if (< (.-innerWidth js/window) 800)
                                                      "100%"
                                                      "736px")}
                                     :multiple (:allow_multiple settings)
                                     :freeSolo true ;;implyOther (when we implement it)
                                     :options       @dropdown-options
                                     :on-change     (fn [event new-value]
                                                      (get-selected-values selected-values new-value))
                                     :render-input  (react-component [props]
                                                                     [text-field (merge props
                                                                                        {:label "Autocomplete"})])
                                     :render-option (react-component [props option]
                                                                     [:li props
                                                                      (:label option)])
                                     :on-input-change (fn [event new-value] ;;if not there, label
                                                        )}]
                  [:div {
                         ;:class (warning-notification)
                         } ""]
                  [gap :size "24px"]
                  ;; [v-box
                  ;;  :class (action-button-area-style)
                  ;;  :src (at)
                  ;;  :gap "48px"
                  ;;  :children [[re-com/button
                  ;;              :label (get-button-label {:index index :input-data input-data :form-messages form-messages})
                  ;;              :class (action-button-style {:theme-data theme-data})
                  ;;              :disabled? (and (:is_required settings) (zero? (count @selected-values)))
                  ;;              :on-click #(do
                  ;;                           ((re-frame/dispatch [::events/update-input-local {:input-data input-data :key (keyword field-id) :value @selected-values}])
                  ;;                            (reset! current-page (+ 1 index))
                  ;;                            (regenerate-display-fields
                  ;;                             (update input-data (keyword field-id) (fn [value]
                  ;;                                                                     (assoc value :value @selected-values))))
                  ;;                            (when (= (+ 1 index) (- (count input-data) 1))
                  ;;                              (on-submit))))]]]
                  ]])))